const SET_BUDGETSYSTEM = 'setBudgetSystem'
const SET_BUDGETSYSTEMS = 'setBudgetSystems'

export const mutationTypes = {
  SET_BUDGETSYSTEM,
  SET_BUDGETSYSTEMS
}

export const mutations = {
  [SET_BUDGETSYSTEM] (state, payload) {
    state.budgetsystem = payload
  },

  [SET_BUDGETSYSTEMS] (state, payload) {
    state.budgetsystems = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/budgetsystem/mutations.js